<template>
  <div
    v-if="
      !item.hidden && (item.children == undefined || item.children.length > 0)
    "
    class="menu-wrapper"
  >
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link
        v-if="
          onlyOneChild.meta &&
          (item.children == undefined ||
            (item.children != undefined && item.children.length > 0))
        "
        :to="resolvePath(onlyOneChild.path)"
      >
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <template
            v-if="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
          >
            <img
              v-if="item.meta.icon.startsWith('tako-')"
              class="tako-menu-icon png-icon"
              :src="
                '/assets/images/menu-icons/' +
                onlyOneChild.meta.icon.replace('tako-', '') +
                '.png'
              "
            />
            <i
              v-else
              :class="getIcon(onlyOneChild, item)"
              :title="onlyOneChild.meta.title"
            />
          </template>
          <template #title>
            <span style="margin-left:4px;">{{ onlyOneChild.meta.title }}</span>
          </template>
        </el-menu-item>
      </app-link>
    </template>

    <template v-else-if="item.children.length > 0 && item.hiddenSelfOnly">
      <sidebar-item
        v-for="(child, index) in item.children"
        :key="child.path + index"
        :item="child"
        :base-path="resolvePath(child.path)"
      />
    </template>

    <el-sub-menu
      v-else-if="item.children.length > 0"
      ref="subMenu"
      :index="resolvePath(item.path, item.meta.openflag)"
      popper-append-to-body
    >
      <template #title>
        <template v-if="item.meta && item.meta.icon">
          <img
            v-if="item.meta.icon.startsWith('tako-')"
            class="tako-menu-icon png-icon"
            :src="
              '/assets/images/menu-icons/' +
              item.meta.icon.replace('tako-', '') +
              '.png'
            "
          />
          <i
            v-else
            :class="getIcon(item, item)"
            :title="item.meta.title"
          />
        </template>
        <span style="margin-left:4px;">{{ item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="(child, index) in item.children"
        :key="child.path + index"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-sub-menu>
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "../../../Utils/UtilTools";
import AppLink from "./AppLink.vue";
import FixiOSBug from "./FixiOSBug";
export default {
  name: "SidebarItem",
  components: { AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = {
          ...parent,
          path: "",
          noShowingChildren: true,
        };
        return true;
      }

      return false;
    },
    resolvePath(routePath, openflag) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      let _index = path.resolve(this.basePath, routePath);
      if (openflag == "true") {
        this.$store.dispatch("changeopenmenu", _index);
      }
      return _index;
    },
    getIcon(onlyOneChild, item) {
      let icon = onlyOneChild.meta.icon || (item.meta && item.meta.icon);
      let spaniconclass = "svg-icon  iconfont " + icon + " ";
      return spaniconclass;
    },
  },
};
</script>

<style>
.tako-menu-icon {
  width: 14px;
}

.tako-menu-icon.png-icon {
  position: relative;
  bottom: 0px;
}

.el-menu-item.is-active .tako-menu-icon.png-icon {
  left: -80px;
  -webkit-filter: drop-shadow(80px 0 #1f86e4);
  filter: drop-shadow(80px 0 #1f86e4);
}
</style>